import { EditorState } from 'prosemirror-state';
import { addRow, selectionCell, TableMap } from 'prosemirror-tables';
import { Decoration, DecorationSet } from 'prosemirror-view';

import { TFunction } from '@lyearn/i18n';

import { getTable } from '../utils';

const addRowDecoration = (state: EditorState, t: TFunction) => {
  const table = getTable(state);

  if (table) {
    const colSpan = table.node.content.firstChild?.content.childCount;
    const $pos = selectionCell(state)!;
    const tableNode = $pos?.node(-1);
    const map = TableMap.get(tableNode);
    const tableStart = table.start;
    const lastRowLastCellSize = table.node.content.lastChild?.content.lastChild?.nodeSize;

    return DecorationSet.create(state.doc, [
      Decoration.widget(table?.start + table.node.nodeSize - 2, (view, getPos) => {
        if (!view.editable || !getPos) {
          return document.createElement('div');
        }
        const pos = getPos();
        if (typeof pos !== 'number') {
          return document.createElement('div');
        }
        const rowElement = document.createElement('tr');
        const cell = rowElement.insertCell(0);
        const rect = map.findCell(pos - tableStart - lastRowLastCellSize! - 1);

        cell.addEventListener('mousedown', () => {
          view.dispatch(
            addRow(state.tr, { map, tableStart, table: tableNode, ...rect }, rect.bottom),
          );
        });
        cell.classList.add('body-short-03', 'ps-48');
        cell.colSpan = colSpan ? colSpan + 1 : 1;

        // Show the instruction inline (small text) instead of a tooltip.
        const isMac =
          typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);
        const addRowShortcut = isMac ? '⌘⇧Enter' : 'Ctrl+Shift+Enter';
        const deleteRowShortcut = isMac ? '⌘⇧⌫' : 'Ctrl+Shift+Backspace';
        const addColShortcut = isMac ? '⌘⇧→' : 'Ctrl+Shift+→';
        const deleteColShortcut = isMac ? '⌘⇧←' : 'Ctrl+Shift+←';

        cell.innerHTML = `${t(
          'Lygo:NewRow',
        )} <span class="text-xs opacity-70 ml-2" aria-hidden="true">(${addRowShortcut})</span> <span class="mx-2 text-xs opacity-40" aria-hidden="true">·</span> ${t(
          'Lygo:DeleteRow',
        )} <span class="text-xs opacity-70 ml-2" aria-hidden="true">(${deleteRowShortcut})</span> <span class="mx-2 text-xs opacity-40" aria-hidden="true">|</span> ${t(
          'Lygo:NewColumn',
        )} <span class="text-xs opacity-70 ml-2" aria-hidden="true">(${addColShortcut})</span> <span class="mx-2 text-xs opacity-40" aria-hidden="true">·</span> ${t(
          'Lygo:DeleteColumn',
        )} <span class="text-xs opacity-70 ml-2" aria-hidden="true">(${deleteColShortcut})</span>`;

        return rowElement;
      }),
    ]);
  }

  return null;
};

export default addRowDecoration;
